module.exports = __webpack_public_path__ + "img/shinkansen_mid_banner2.2cfd2c1e.png";